import React from 'react';

import { InitialAvatarContainer, InitialAvatarName } from './styles';
import { InitialAvatarProps } from './types';
import { getColorFromInitials } from '../utils';

const InitialAvatar: React.FunctionComponent<InitialAvatarProps> = ({
  name,
  size = 'medium',
  ...props
}): React.ReactElement => {
  const initials = React.useMemo(() => {
    if (props.disableFormattedName) {
      return name ?? '';
    }

    // Notifications from public submissions have no creator, so name can arrive undefined/empty.
    const safeName = (name ?? '').trim();
    if (!safeName) {
      return '';
    }

    const nameParts = safeName.toUpperCase().split(' ');
    let initialParts = nameParts[0].substring(0, 1);

    if (nameParts.length > 1) {
      initialParts += nameParts[nameParts.length - 1].substring(0, 1);
    }
    return initialParts;
  }, [name]);

  const color = getColorFromInitials(initials[0], initials[1] || initials[0]);

  return (
    <InitialAvatarContainer $color={color || '#b616e4'} $size={size} {...props}>
      <InitialAvatarName size={size}>{initials}</InitialAvatarName>
    </InitialAvatarContainer>
  );
};

export default InitialAvatar;
